import Web3 from 'web3'
import { useLayoutStore, useWalletStore } from '@/store'

export async function connectWallet() {
  if (!window.ethereum) {
    alert('Web3 provider was not found in this browser...')
    throw new Error('Web3 provider was not found in this browser...')
  }

  let isConnected = false

  const walletStore = useWalletStore()
  const layoutStore = useLayoutStore()

  const chainId = window.ethereum.networkVersion

  if (chainId !== '1') {
    alert('Switch wallet chain to Ethereum Mainnet!')
    throw new Error('Switch wallet chain to Ethereum Mainnet!')
  }

  try {
    const web3 = new Web3()

    const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' })
    web3.setProvider(window.ethereum)

    walletStore.address = accounts[0]
    walletStore.web3 = web3

    window.ethereum.on('disconnect', () => window.location.reload())
    window.ethereum.on('accountsChanged', () => window.location.reload())
    window.ethereum.on('chainChanged', () => window.location.reload());

    isConnected = true
  } catch (e) {
    layoutStore.stopLoading()
  }

  return isConnected
}